<template>
  <div class="mulu rmulu">
    <li v-for="(item, index) in mulu" :key="index">
      <p class="ellipsis-aRow" @click="clickmulu(item)">
        {{ item.label }}
      </p>
      <xmlTree class="subitems" :mulu="item.subitems" @clickmulu="clickmulu" />
      <!-- <ul v-if="item.subitems.length" class="twomulu">
        <li
          v-for="(item2, index2) in item.subitems"
          :key="index2"
          @click="clickmulu(item2)"
        >
          {{ item2.label }}
        </li>
      </ul> -->
    </li>
  </div>
</template>
<script>
import xmlTree from './xmlTree.vue'
export default {
  name: "xmlTree",
  components: { xmlTree },
  props: {
    mulu: Array,
  },
  methods: {
    clickmulu(item) {
        console.log(item,'kkkkkkkkkkkkkkk');
      this.$emit("clickmulu", item);
    },
  },
};
</script>

<style >
.mulu {
  width: 100%;
  max-height: calc(100vh - 130px);
  float: left;
  /* padding: 15px 24px; */
  box-sizing: border-box;
  position: relative;
  overflow: auto;
  overflow-x: hidden;
}
.bookmark-item {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.mulu::-webkit-scrollbar {
  width: 5px;
  /*height: 4px;*/
}

.mulu::-webkit-scrollbar-thumb {
  border-radius: 15px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #fbfbfb;
}

.mulu::-webkit-scrollbar-track {
  border-radius: 0;
}

.subitems{
    padding-left: 16px;
}
.mulu  li {
  list-style: none;
  width: 100%;
  float: left;
  /* border-bottom: 1px dashed #ccc; */
}

.rmulu li {
  cursor: pointer;
}

.mulu > li > p {
  width: 100%;
  float: left;
  font-size: 13px;
  font-family: PingFang SC;
  padding-bottom: 5px;
  font-weight: 400;
  color: #666666;
  padding: 6px 4px;
}
.mulu p:hover{
    background-color: #f5f5f5;
}
</style>
